// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#logo-side {\n  width: 175px;\n  height: 41px;\n}\n#logo-side .st0 {\n  fill: #fff;\n}\n#logo-side .st1 {\n  fill: #e1251b;\n}", ""]);
// Exports
module.exports = exports;
